/* eslint-disable */
!(function (t) {
  var e = {};
  function o(i) {
    if (e[i]) return e[i].exports;
    var n = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(n.exports, n, n.exports, o), (n.l = !0), n.exports;
  }
  (o.m = t),
    (o.c = e),
    (o.d = function (t, e, i) {
      o.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (o.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (o.t = function (t, e) {
      if ((1 & e && (t = o(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if ((o.r(i), Object.defineProperty(i, 'default', { enumerable: !0, value: t }), 2 & e && 'string' != typeof t))
        for (var n in t)
          o.d(
            i,
            n,
            function (e) {
              return t[e];
            }.bind(null, n)
          );
      return i;
    }),
    (o.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return o.d(e, 'a', e), e;
    }),
    (o.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (o.p = ''),
    o((o.s = 3));
})([
  function (t, e, o) {
    var i = o(1);
    i && i.__esModule && (i = i.default), (t.exports = 'string' == typeof i ? i : i.toString());
  },
  function (t, e, o) {
    (e = o(2)(!1)).push([
      t.i,
      ".social-btn{display:inline-block;height:60px;width:60px;cursor:pointer;background-repeat:no-repeat;background-position:center;position:relative;flex-shrink:0;padding-left:0;padding-right:0;border-radius:30px;box-sizing:border-box}.social-btn:before{content:'';display:block;position:absolute;left:50%;top:50%;transform:translateX(-50%) translateY(-50%);background-size:contain;background-position:center;background-repeat:no-repeat}.social-btn_fb{background-color:#4861A3}.social-btn_fb:hover{background-color:#5777CC}.social-btn_fb:active{background-color:#374C82}.social-btn_fb:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_vk{background-color:#597DA2}.social-btn_vk:hover{background-color:#678EB6}.social-btn_vk:active{background-color:#446A91}.social-btn_vk:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M20.8,7.74C20.93,7.32 20.8,7 20.18,7H18.16C17.64,7 17.41,7.27 17.28,7.57C17.28,7.57 16.25,10.08 14.79,11.72C14.31,12.19 14.1,12.34 13.84,12.34C13.71,12.34 13.5,12.19 13.5,11.76V7.74C13.5,7.23 13.38,7 12.95,7H9.76C9.44,7 9.25,7.24 9.25,7.47C9.25,7.95 10,8.07 10.05,9.44V12.42C10.05,13.08 9.93,13.2 9.68,13.2C9,13.2 7.32,10.67 6.33,7.79C6.13,7.23 5.94,7 5.42,7H3.39C2.82,7 2.7,7.27 2.7,7.57C2.7,8.11 3.39,10.77 5.9,14.29C7.57,16.7 9.93,18 12.08,18C13.37,18 13.53,17.71 13.53,17.21V15.39C13.53,14.82 13.65,14.7 14.06,14.7C14.36,14.7 14.87,14.85 16.07,16C17.45,17.38 17.67,18 18.45,18H20.47C21.05,18 21.34,17.71 21.18,17.14C21,16.57 20.34,15.74 19.47,14.76C19,14.21 18.29,13.61 18.07,13.3C17.77,12.92 17.86,12.75 18.07,12.4C18.07,12.4 20.54,8.93 20.8,7.74Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_tw{background-color:#000000}.social-btn_tw:hover{background-color:#191919}.social-btn_tw:active{background-color:#090909}.social-btn_tw:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,%3Csvg width='35' height='36' viewBox='0 0 35 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M26.6013 3.78125H31.4255L20.8861 15.8271L33.2848 32.2187H23.5767L15.973 22.2773L7.27255 32.2187H2.44547L13.7184 19.3344L1.82422 3.78125L11.7788 3.78125L18.6519 12.8681L26.6013 3.78125ZM24.9082 29.3312H27.5813L10.3263 6.51708H7.45776L24.9082 29.3312Z' fill='white'/%3E%3C/svg%3E\")}.social-btn_gplus{background-color:#DD5044}.social-btn_gplus:hover{background-color:#FB5446}.social-btn_gplus:active{background-color:#BF4339}.social-btn_gplus:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_mail,.social-btn_eml{background-color:#fff;border:1px solid #CDCDCD}.social-btn_mail:hover,.social-btn_eml:hover{border:2px solid #4285F4;background-color:#fff}.social-btn_mail:active,.social-btn_eml:active{background-color:#D6D6D6;border-color:#D6D6D6}.social-btn_mail:before,.social-btn_eml:before{width:38px;height:38px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z' fill='%23494949' fill-rule='evenodd'/></svg>\")}.social-btn_cp{background-color:#fff;border:1px solid #CDCDCD}.social-btn_cp:hover{border:2px solid #4285F4;background-color:#fff}.social-btn_cp:active{background-color:#D6D6D6;border-color:#D6D6D6}.social-btn_cp:before{width:38px;height:38px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fill='%23494949' d='M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z'/></svg>\")}.social-btn_ns{background-color:#fff;border:1px solid #CDCDCD}.social-btn_ns:hover{border:2px solid #4285F4;background-color:#fff}.social-btn_ns:active{background-color:#D6D6D6;border-color:#D6D6D6}.social-btn_ns:before{width:38px;height:38px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fill='%23494949' d='M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z'/></svg>\")}.social-btn_vb{background-color:#665CAC}.social-btn_vb:hover{background-color:#776DBF}.social-btn_vb:active{background-color:#554C93}.social-btn_vb:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M12.892 13.745s.427.038.656-.247l.448-.563c.216-.28.738-.458 1.249-.174.676.382 1.55.982 2.149 1.541.33.278.407.688.182 1.121l-.002.009c-.232.408-.541.791-.932 1.148l-.009.006c-.44.367-.946.58-1.487.404l-.01-.014c-.972-.275-3.304-1.464-4.79-2.649-2.431-1.918-4.159-5.082-4.637-6.778l-.015-.01c-.176-.543.039-1.049.404-1.488l.007-.008c.357-.391.739-.701 1.148-.932l.009-.002c.432-.225.842-.149 1.121.182.367.379 1.056 1.291 1.54 2.149.284.51.106 1.033-.173 1.248l-.564.448c-.284.23-.247.657-.247.657s.834 3.156 3.953 3.952zm4.907-2.616c-.167 0-.303-.135-.304-.302-.014-1.83-.564-3.288-1.634-4.332-1.072-1.045-2.427-1.581-4.027-1.592-.168-.001-.303-.138-.301-.306.001-.167.136-.301.303-.301h.002c1.762.012 3.258.606 4.447 1.764 1.19 1.162 1.802 2.765 1.817 4.763.001.167-.133.304-.301.306h-.002zm-1.595-.624h-.007c-.168-.004-.301-.143-.297-.31.024-1.038-.273-1.878-.906-2.569-.63-.689-1.495-1.065-2.645-1.149-.167-.013-.293-.158-.281-.325.013-.167.158-.293.325-.281 1.294.095 2.32.548 3.049 1.345.733.8 1.092 1.807 1.065 2.992-.004.165-.139.297-.303.297zm-1.558-.522c-.161 0-.295-.126-.303-.289-.051-1.03-.537-1.534-1.527-1.588-.168-.009-.296-.152-.287-.319.009-.168.151-.296.319-.287 1.308.07 2.034.819 2.101 2.164.009.167-.12.31-.288.318l-.015.001zm6.817 3.469c-.605 4.877-4.172 5.185-4.83 5.396-.28.09-2.882.737-6.152.524 0 0-2.438 2.94-3.199 3.705-.119.119-.258.167-.352.145-.131-.032-.167-.188-.165-.414l.02-4.016v-.001c-4.762-1.323-4.485-6.295-4.431-8.898.054-2.603.543-4.736 1.996-6.17 2.61-2.364 7.987-2.011 7.987-2.011 4.541.02 6.717 1.387 7.222 1.845 1.675 1.434 2.528 4.867 1.904 9.895zm-.652-11.113c-.597-.548-3.007-2.298-8.375-2.322 0 0-6.33-.382-9.416 2.45-1.718 1.718-2.322 4.231-2.386 7.348-.063 3.118-.146 8.958 5.484 10.542l.006.002-.004 2.416s-.035.979.609 1.179c.779.241 1.236-.502 1.981-1.304.408-.44.971-1.086 1.397-1.58 3.851.322 6.812-.417 7.149-.526.777-.253 5.177-.816 5.893-6.657.738-6.022-.358-9.83-2.338-11.548z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_wa{background-color:#1DC93B}.social-btn_wa:hover{background-color:#29D046}.social-btn_wa:active{background-color:#19A131}.social-btn_wa:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='-1 1 25 23' xmlns='http://www.w3.org/2000/svg'><path d='M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_tg{background-color:#31A5E0}.social-btn_tg:hover{background-color:#46B9F3}.social-btn_tg:active{background-color:#2D8BBB}.social-btn_tg:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_th{background-color:#36465D}.social-btn_th:hover{background-color:#455772}.social-btn_th:active{background-color:#242E3B}.social-btn_th:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='1 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M17,11H13V15.5C13,16.44 13.28,17 14.5,17H17V21C17,21 15.54,21.05 14.17,21.05C10.8,21.05 9.5,19 9.5,16.75V11H7V7C10.07,6.74 10.27,4.5 10.5,3H13V7H17' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_pt{background-color:#fff;border:1px solid #CDCDCD}.social-btn_pt:hover{border:2px solid #4285F4;background-color:#fff}.social-btn_pt:active{background-color:#D6D6D6;border-color:#D6D6D6}.social-btn_pt:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M9.04,21.54C10,21.83 10.97,22 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z' fill='%23BD081C' fill-rule='evenodd'/></svg>\")}.social-btn_ln{background-color:#3ACE01}.social-btn_ln:hover{background-color:#4EDF16}.social-btn_ln:active{background-color:#43BC15}.social-btn_ln:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='45 45 280 280'><path fill-rule='evenodd' clip-rule='evenodd' fill='%23FFF' d='M188.515 62.576c76.543 0 138.593 49.687 138.593 110.979 0 21.409-7.576 41.398-20.691 58.351-.649.965-1.497 2.031-2.566 3.209l-.081.088c-4.48 5.36-9.525 10.392-15.072 15.037-38.326 35.425-101.41 77.601-109.736 71.094-7.238-5.656 11.921-33.321-10.183-37.925-1.542-.177-3.08-.367-4.605-.583l-.029-.002v-.002c-64.921-9.223-114.222-54.634-114.222-109.267-.002-61.292 62.049-110.979 138.592-110.979z'/><path fill-rule='evenodd' clip-rule='evenodd' fill='%233ACE01' d='M108.103 208.954h27.952c3.976 0 7.228-3.253 7.228-7.229v-.603c0-3.976-3.252-7.228-7.228-7.228h-20.121v-45.779c0-3.976-3.252-7.228-7.228-7.228h-.603c-3.976 0-7.228 3.252-7.228 7.228v53.609c0 3.977 3.252 7.23 7.228 7.23zm173.205-33.603v-.603c0-3.976-3.253-7.228-7.229-7.228h-20.12v-11.445h20.12c3.976 0 7.229-3.252 7.229-7.228v-.603c0-3.976-3.253-7.228-7.229-7.228h-27.952c-3.976 0-7.228 3.252-7.228 7.228v53.609c0 3.976 3.252 7.229 7.228 7.229h27.952c3.976 0 7.229-3.253 7.229-7.229v-.603c0-3.976-3.253-7.228-7.229-7.228h-20.12v-11.445h20.12c3.976.002 7.229-3.251 7.229-7.226zm-53.755 31.448l.002-.003a7.207 7.207 0 0 0 2.09-5.07v-53.609c0-3.976-3.252-7.228-7.229-7.228h-.603c-3.976 0-7.228 3.252-7.228 7.228v31.469l-26.126-35.042c-1.248-2.179-3.598-3.655-6.276-3.655h-.603c-3.976 0-7.229 3.252-7.229 7.228v53.609c0 3.976 3.252 7.229 7.229 7.229h.603c3.976 0 7.228-3.253 7.228-7.229v-32.058l26.314 35.941c.162.252.339.494.53.724l.001.002c.723.986 1.712 1.662 2.814 2.075.847.35 1.773.544 2.742.544h.603a7.162 7.162 0 0 0 3.377-.844c.723-.344 1.332-.788 1.761-1.311zm-71.208 2.155h.603c3.976 0 7.228-3.253 7.228-7.229v-53.609c0-3.976-3.252-7.228-7.228-7.228h-.603c-3.976 0-7.229 3.252-7.229 7.228v53.609c0 3.976 3.253 7.229 7.229 7.229z'/></svg>\")}.social-btn_li{background-color:#017AB6}.social-btn_li:hover{background-color:#0A8DCE}.social-btn_li:active{background-color:#096B9C}.social-btn_li:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='1 1 21 21' xmlns='http://www.w3.org/2000/svg'><path d='M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M18.5,18.5V13.2A3.26,3.26 0 0,0 15.24,9.94C14.39,9.94 13.4,10.46 12.92,11.24V10.13H10.13V18.5H12.92V13.57C12.92,12.8 13.54,12.17 14.31,12.17A1.4,1.4 0 0,1 15.71,13.57V18.5H18.5M6.88,8.56A1.68,1.68 0 0,0 8.56,6.88C8.56,5.95 7.81,5.19 6.88,5.19A1.69,1.69 0 0,0 5.19,6.88C5.19,7.81 5.95,8.56 6.88,8.56M8.27,18.5V10.13H5.5V18.5H8.27Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_flb{background-color:#F01B23}.social-btn_flb:hover{background-color:#F9343C}.social-btn_flb:active{background-color:#DB171E}.social-btn_flb:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><g shape-rendering='crispEdges' fill='white'><rect x='40' y='40' width='20' height='20' opacity='0.8' /><rect x='40' y='20' width='40' height='20' opacity='0.9' /><rect x='20' y='20' width='20' height='60' /></g></svg>\")}.social-btn_rd{background-color:#FF4500}.social-btn_rd:hover{background-color:#FF642A}.social-btn_rd:active{background-color:#E34206}.social-btn_rd:before{width:40px;height:40px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M22,12.14C22,10.92 21,9.96 19.81,9.96C19.22,9.96 18.68,10.19 18.29,10.57C16.79,9.5 14.72,8.79 12.43,8.7L13.43,4L16.7,4.71C16.73,5.53 17.41,6.19 18.25,6.19C19.11,6.19 19.81,5.5 19.81,4.63C19.81,3.77 19.11,3.08 18.25,3.08C17.65,3.08 17.11,3.43 16.86,3.95L13.22,3.18C13.11,3.16 13,3.18 12.93,3.24C12.84,3.29 12.79,3.38 12.77,3.5L11.66,8.72C9.33,8.79 7.23,9.5 5.71,10.58C5.32,10.21 4.78,10 4.19,10C2.97,10 2,10.96 2,12.16C2,13.06 2.54,13.81 3.29,14.15C3.25,14.37 3.24,14.58 3.24,14.81C3.24,18.18 7.16,20.93 12,20.93C16.84,20.93 20.76,18.2 20.76,14.81C20.76,14.6 20.75,14.37 20.71,14.15C21.46,13.81 22,13.04 22,12.14M7,13.7C7,12.84 7.68,12.14 8.54,12.14C9.4,12.14 10.1,12.84 10.1,13.7A1.56,1.56 0 0,1 8.54,15.26C7.68,15.28 7,14.56 7,13.7M15.71,17.84C14.63,18.92 12.59,19 12,19C11.39,19 9.35,18.9 8.29,17.84C8.13,17.68 8.13,17.43 8.29,17.27C8.45,17.11 8.7,17.11 8.86,17.27C9.54,17.95 11,18.18 12,18.18C13,18.18 14.47,17.95 15.14,17.27C15.3,17.11 15.55,17.11 15.71,17.27C15.85,17.43 15.85,17.68 15.71,17.84M15.42,15.28C14.56,15.28 13.86,14.58 13.86,13.72A1.56,1.56 0 0,1 15.42,12.16C16.28,12.16 17,12.86 17,13.72C17,14.56 16.28,15.28 15.42,15.28Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn_ok{background-color:#E27E35}.social-btn_ok:hover{background-color:#EF9554}.social-btn_ok:active{background-color:#F29C5D}.social-btn_ok:before{width:32px;height:32px;background-image:url(\"data:image/svg+xml,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M17.83,12.74C17.55,12.17 16.76,11.69 15.71,12.5C14.28,13.64 12,13.64 12,13.64C12,13.64 9.72,13.64 8.29,12.5C7.24,11.69 6.45,12.17 6.17,12.74C5.67,13.74 6.23,14.23 7.5,15.04C8.59,15.74 10.08,16 11.04,16.1L10.24,16.9C9.1,18.03 8,19.12 7.25,19.88C6.8,20.34 6.8,21.07 7.25,21.5L7.39,21.66C7.84,22.11 8.58,22.11 9.03,21.66L12,18.68C13.15,19.81 14.24,20.9 15,21.66C15.45,22.11 16.18,22.11 16.64,21.66L16.77,21.5C17.23,21.07 17.23,20.34 16.77,19.88L13.79,16.9L13,16.09C13.95,16 15.42,15.73 16.5,15.04C17.77,14.23 18.33,13.74 17.83,12.74M12,4.57C13.38,4.57 14.5,5.69 14.5,7.06C14.5,8.44 13.38,9.55 12,9.55C10.62,9.55 9.5,8.44 9.5,7.06C9.5,5.69 10.62,4.57 12,4.57M12,12.12C14.8,12.12 17.06,9.86 17.06,7.06C17.06,4.27 14.8,2 12,2C9.2,2 6.94,4.27 6.94,7.06C6.94,9.86 9.2,12.12 12,12.12Z' fill='%23FFF' fill-rule='evenodd'/></svg>\")}.social-btn:active:before{opacity:.7}.social-btns-title{display:block;text-align:center;font-size:13px;line-height:15px;margin-bottom:20px}.social-btns-title span{display:inline-block;background-color:#fff;border:1px solid #D9D9D9;border-radius:9px;font-size:10px;text-transform:uppercase;color:#303030;font-weight:bold;margin-right:3px;padding-left:5px;padding-right:5px}.social-btns{display:inline-flex;align-items:center;margin:0 auto;flex-wrap:wrap;max-width:600px;position:relative}.social-btns .social-btn{margin-right:7px}.social-btns .social-btn span{display:none}.social-btns .social-btns__list .social-btns__legend{display:none}.social-btns_size_s .social-btn{width:40px;height:40px;border-radius:20px}.social-btns_size_s .social-btn_vk:before{width:22px;height:22px}.social-btns_size_s .social-btn_fb:before{width:22px;height:22px}.social-btns_size_s .social-btn_tw:before{width:22px;height:22px}.social-btns_size_s .social-btn_wa:before{width:22px;height:22px}.social-btns_size_s .social-btn_tg:before{width:22px;height:22px}.social-btns_size_s .social-btn_gplus:before{width:22px;height:22px}.social-btns_size_s .social-btn_mail:before,.social-btns_size_s .social-btn_eml:before{width:22px;height:22px}.social-btns_size_s .social-btn_cp:before{width:22px;height:22px}.social-btns_size_s .social-btn_ns:before{width:22px;height:22px}.social-btns_size_s .social-btn_vb:before{width:22px;height:22px}.social-btns_size_s .social-btn_wa:before{width:22px;height:22px}.social-btns_size_s .social-btn_th:before{width:22px;height:22px}.social-btns_size_s .social-btn_pt:before{width:22px;height:22px}.social-btns_size_s .social-btn_ln:before{width:22px;height:22px}.social-btns_size_s .social-btn_li:before{width:22px;height:22px}.social-btns_size_s .social-btn_flb:before{width:22px;height:22px}.social-btns_size_s .social-btn_rd:before{width:26px;height:26px}.social-btns_size_s .social-btn_ok:before{width:22px;height:22px}.social-btns_size_s .social-btns__list{width:130px}.social-btns_size_s .social-btns__more{width:40px;height:40px;border-radius:20px}.social-btns_size_m .social-btn{width:56px;height:56px;margin-right:8px;border-radius:28px}.social-btns_size_m .social-btns__list{width:162px}.social-btns_size_m .social-btns__list .social-btn{margin-right:0}.social-btns_size_m .social-btns__more{width:56px;height:56px;border-radius:28px}.social-btns__more{display:block;height:60px;width:60px;border-radius:320px;cursor:pointer;border:none;outline:none;position:relative;background-color:#FFFFFF;box-shadow:inset 0px 0px 0px 1px #CDCDCD}.social-btns__more:before,.social-btns__more::after{content:'';display:block;position:absolute;background-color:#494949;top:50%;left:50%;transform:translateX(-50%) translateY(-50%)}.social-btns__more:before{width:2px;height:16px;top:50%}.social-btns__more:after{width:16px;height:2px}.social-btns__more:hover{box-shadow:inset 0px 0px 0px 2px #4285F4}.social-btns__more:hover:after,.social-btns__more:hover:before{background-color:#4285F4}.social-btns__list{display:none;justify-content:space-between;flex-wrap:wrap;padding-left:20px;padding-right:20px;padding-top:20px;padding-bottom:10px;box-shadow:0 2px 6px 0 rgba(0,0,0,0.2);background-color:#fff;position:absolute;right:0;top:0;transform:translateX(46px) translateY(calc(-100% + 5px));z-index:100;border-radius:24px;width:170px;box-sizing:border-box}.social-btns__list .social-btn{margin-bottom:10px;margin-right:0}.social-btns__list.active{display:flex}.social-btns__list_down{top:auto;bottom:0;transform:translateX(46px) translateY(calc(100% - 5px))}@media screen and (max-width: 800px){.social-btn{display:block;height:40px;width:40px;border-radius:20px;cursor:pointer;outline:none;background-repeat:no-repeat;background-position:center;position:relative;flex-shrink:0}.social-btn_vk:before{width:22px;height:22px}.social-btn_fb:before{width:22px;height:22px}.social-btn_tw:before{width:22px;height:22px}.social-btn_wa:before{width:22px;height:22px}.social-btn_tg:before{width:22px;height:22px}.social-btn_gplus:before{width:22px;height:22px}.social-btn_mail:before,.social-btn_eml:before{width:22px;height:22px}.social-btn_cp:before{width:22px;height:22px}.social-btn_ns:before{width:22px;height:22px}.social-btn_vb:before{width:22px;height:22px}.social-btn_wa:before{width:22px;height:22px}.social-btn_th:before{width:22px;height:22px}.social-btn_pt:before{width:22px;height:22px}.social-btn_ln:before{width:22px;height:22px}.social-btn_li:before{width:22px;height:22px}.social-btn_flb:before{width:22px;height:22px}.social-btn_rd:before{width:26px;height:26px}.social-btn_ok:before{width:22px;height:22px}.social-btns{max-width:400px}.social-btns .social-btn{margin-right:5px;margin-bottom:5px}.social-btns__more{width:40px;height:40px;border-radius:20px;left:0}.social-btns__list{width:130px}.social-btns__list .social-btn{margin-right:0}}\n",
      '',
    ]),
      (t.exports = e);
  },
  function (t, e, o) {
    'use strict';
    t.exports = function (t) {
      var e = [];
      return (
        (e.toString = function () {
          return this.map(function (e) {
            var o = (function (t, e) {
              var o = t[1] || '',
                i = t[3];
              if (!i) return o;
              if (e && 'function' == typeof btoa) {
                var n =
                    ((a = i),
                    (s = btoa(unescape(encodeURIComponent(JSON.stringify(a))))),
                    (l = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(s)),
                    '/*# '.concat(l, ' */')),
                  r = i.sources.map(function (t) {
                    return '/*# sourceURL='.concat(i.sourceRoot || '').concat(t, ' */');
                  });
                return [o].concat(r).concat([n]).join('\n');
              }
              var a, s, l;
              return [o].join('\n');
            })(e, t);
            return e[2] ? '@media '.concat(e[2], ' {').concat(o, '}') : o;
          }).join('');
        }),
        (e.i = function (t, o, i) {
          'string' == typeof t && (t = [[null, t, '']]);
          var n = {};
          if (i)
            for (var r = 0; r < this.length; r++) {
              var a = this[r][0];
              null != a && (n[a] = !0);
            }
          for (var s = 0; s < t.length; s++) {
            var l = [].concat(t[s]);
            (i && n[l[0]]) || (o && (l[2] ? (l[2] = ''.concat(o, ' and ').concat(l[2])) : (l[2] = o)), e.push(l));
          }
        }),
        e
      );
    };
  },
  function (t, e, o) {
    'use strict';
    o.r(e);
    var i = function (t, e) {
        do {
          if (t.classList && t.classList.contains(e)) return t;
        } while ((t = t.parentNode));
      },
      n = function (t) {
        return t && 'object' == typeof t && !Array.isArray(t);
      },
      r = function (t) {
        return t.target || t.srcElement;
      },
      a = function (t) {
        return t.parentNode.removeChild(t);
      },
      s = function (t, e) {
        var o = t.createElement('input');
        return (
          o.setAttribute('type', 'text'),
          o.setAttribute('value', e),
          (o.style.position = 'absolute'),
          (o.style.left = '-9999px'),
          t.body.appendChild(o),
          o
        );
      },
      l = function (t) {
        return t.replace(/-([a-z])/gi, function (t, e) {
          return e.toUpperCase();
        });
      },
      c = function (t) {
        var e = [];
        for (var o in t) e.push(encodeURIComponent(o) + '=' + encodeURIComponent(t[o]));
        return e.join('&');
      },
      b = {
        get: function (t, e) {
          for (var o = 0, i = (e = e.split('.')).length; o < i && void 0 !== t; o++) t = t[e[o]];
          return t;
        },
        set: function (t, e, o) {
          for (var i = t, n = 0, r = (e = e.split('.')).length; n < r; n++) {
            var a = e[n];
            void 0 === t[a] && (t[a] = {}), n === r - 1 && (t[a] = o), (t = t[a]);
          }
          return i;
        },
        delete: function (t, e) {
          for (var o = 0, i = (e = e.split('.')).length; o < i && void 0 !== t; o++)
            if (((t = t[e[o]]), o === i - 1)) return void delete t[e[o]];
        },
        has: function (t, e) {
          for (var o = 0, i = (e = e.split('.')).length; o < i; o++) {
            if (void 0 === t || !(e[o] in t)) return !1;
            t = t[e[o]];
          }
          return !0;
        },
        merge: function (t, e) {
          for (var o in e)
            e.hasOwnProperty(o) &&
              void 0 !== e[o] &&
              (n(e[o]) ? (o in t || (t[o] = {}), this.merge(t[o], e[o])) : (t[o] = e[o]));
        },
      },
      d = {
        hooks: { onready: function () {}, onshare: function () {} },
        theme: {
          bare: !1,
          host: '',
          limit: 6,
          nonce: '',
          nsForCp: !1,
          popupDirection: 'top',
          services: 'fb,tw,wa,tg,rd,pt,eml,li,flb,vk,th,ln,vb',
          size: '',
          direction: 'horizontal',
          hint: {
            fb: 'Share on Facebook',
            tw: 'Share on X',
            wa: 'Share on WhatsApp',
            tg: 'Share on Telegram',
            rd: 'Share on Reddit',
            pt: 'Share on Pinterest',
            eml: 'Share by email',
            li: 'Share on Linkedin',
            flb: 'Share on Flipboard',
            vk: 'Share on VK',
            th: 'Share on Tumblr',
            ln: 'Share on LINE',
            vb: 'Share on Viber',
            cp: 'Copy to clipboard',
            ns: 'Share',
          },
          label: {
            fb: 'Facebook',
            tw: 'X',
            wa: 'WhatsApp',
            tg: 'Telegram',
            rd: 'Reddit',
            pt: 'Pinterest',
            eml: 'Email',
            li: 'Linkedin',
            flb: 'Flipboard',
            vk: 'VK',
            th: 'Tumblr',
            ln: 'LINE',
            vb: 'Viber',
            cp: 'Copy link',
            ns: 'Share',
          },
          legend: 'Share this page into',
          pressToCopy: 'Press ctrl+C and Enter to copy',
        },
        content: {
          link_id: '',
          description: '',
          image: '',
          title: document.title,
          url: window.location.href,
        },
        contentByService: {},
      };
    function p(t, e) {
      return (
        '<div class="social-btn social-btn_' +
        t +
        '" data-target="' +
        t +
        '" title="' +
        e.get('theme.hint.' + t) +
        '"><span>' +
        e.get('theme.label.' + t) +
        '</span></div>'
      );
    }
    var h = function (t) {
      var e = '',
        o = t.get('theme.services').split(',');
      if (t.get('theme.nsForCp') && navigator.share) {
        var i = o.indexOf('cp');
        -1 !== i && (o[i] = 'ns');
      }
      for (var n = t.get('theme.limit'), r = 0, a = o.length; r < a && r < n; r++) e += p(o[r], t);
      if (n < a) {
        for (
          e += '<div class="social-btns__more"><span></span></div>',
            e += '<div class="social-btns__list">',
            e += '<div class="social-btns__legend">' + t.get('theme.legend') + '</div>',
            r = n;
          r < a;
          r++
        )
          e += p(o[r], t);
        e += '</div>';
      }
      return e;
    };
    let g = !1,
      u = o(0),
      f = {
        _defaults: { group: 'content', type: 'string' },
        bare: { group: 'theme', type: 'boolean' },
        host: { group: 'theme', type: 'string' },
        limit: { group: 'theme', type: 'string' },
        nonce: { group: 'theme', type: 'string' },
        hint: { group: 'theme.hint', type: 'string' },
        label: { group: 'theme.label', type: 'string' },
        legend: { group: 'theme', type: 'string' },
        pressToCopy: { group: 'theme', type: 'string' },
        nsForCp: { group: 'theme', type: 'boolean' },
        popupDirection: { group: 'theme', type: 'string' },
        services: { group: 'theme', type: 'string' },
        size: { group: 'theme', type: 'string' },
        direction: { group: 'theme', type: 'string' },
      },
      v = {
        fb: [800, 520],
        tw: [550, 420],
        wa: [800, 520],
        tg: [400, 500],
        rd: [800, 520],
        vk: [550, 420],
        pt: [800, 520],
        li: [800, 520],
        flb: [400, 500],
        th: [800, 520],
        ln: [400, 500],
      };
    (window.CT = window.CT || {}),
      (window.CT.share_host = window.CT.share_host || '/share/'),
      (window.CT.share_blank = window.CT.share_blank || !1);
    let x = {
      eml: k,
      vb: k,
      cp: function (t, e) {
        var o = t.get('content', e);
        (o.t = e),
          (o.technique = 'client_redirect'),
          y(C(t) + '?' + c(o), function (e) {
            var o = s(document, e.redirect_url);
            o.select();
            var i = (function () {
              try {
                return document.execCommand('copy');
              } catch (t) {
                return !1;
              }
            })();
            a(o), i || prompt(t.get('theme.pressToCopy'), e.redirect_url);
          });
      },
      ns: function (t, e) {
        if (!navigator.share) return;
        var o = t.get('content', e);
        navigator.share({ url: o.url, title: o.title, text: o.description }).then(function () {
          (o.t = e), (o.technique = 'client_redirect'), y(C(t) + '?' + c(o), function (t) {});
        });
      },
    };
    function w() {
      var t = {};
      return (
        (this.merge = function (e) {
          b.merge(t, e);
        }),
        (this.get = function (e, o) {
          if (o) {
            if ('content' === e) {
              var i = {};
              return b.merge(i, b.get(t, 'content')), b.merge(i, b.get(t, 'contentByService.' + o)), i;
            }
            if (e.match(/^content\./)) {
              var n = e.replace(/^content\./, 'contentByService.' + o + '.'),
                r = b.get(t, n);
              if (void 0 !== r) return r;
            }
          }
          return b.get(t, e);
        }),
        this
      );
    }
    function _(t, e) {
      var o = t.querySelector('.social-btns__list'),
        n = function (n) {
          var a = r(n),
            l = i(a, 'social-btns');
          if (l && l === t) {
            o &&
              (i(a, 'social-btns__more')
                ? o.classList.toggle('active')
                : i(a, '.social-btns__list') || o.classList.remove('active'));
            var c = i(a, 'social-btn');
            if (c) {
              var b = L(t);
              e.merge({
                content: b.content,
                contentByService: b.contentByService,
              });
              var d = c.getAttribute('data-target');
              if ((e.get('hooks.onshare').call(this, d), s())) return;
              (x[d] || m)(e, d);
            }
          } else o && o.classList.remove('active');
        };
      document.body.addEventListener('click', n);
      var a = function (t) {
        switch (t.which || t.keyCode) {
          case 27:
            o.classList.remove('active');
        }
      };
      function s() {
        return !t;
      }
      document.body.addEventListener('keydown', a),
        (this.updateContent = function (o) {
          if (s()) throw new Error('Could not operate on destroyed block.');
          e.merge({ content: o }), D(t, e);
        }),
        (this.updateContent = function (o) {
          if (s()) throw new Error('Could not operate on destroyed block.');
          e.merge({ contentByService: o }), D(t, e);
        }),
        (this.destroy = function () {
          if (s()) throw new Error('Could not operate on destroyed block.');
          var i = e.get('theme.size');
          i && t.classList.remove('social-btns_size_' + i),
            t.classList.remove('social-btns_inited'),
            (t.innerHTML = ''),
            (t = null),
            document.body.removeEventListener('click', n),
            document.body.removeEventListener('key', a),
            (o = null);
        }),
        e.get('hooks.onready').call(this);
    }
    function C(t) {
      return t.get('theme.host') || window.CT.share_host;
    }
    function m(t, e) {
      var o = t.get('content', e);
      (o.t = e),
        (function (t, e) {
          if (window.CT.share_blank) window.open(t, '_blank');
          else {
            var o = v[e],
              i = o ? o[0] : 400,
              n = o ? o[1] : 500,
              r = window.outerHeight / 2 + window.screenY - n / 2,
              a = window.outerWidth / 2 + window.screenX - i / 2;
            window.open(
              t,
              '',
              'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
                i +
                ', height=' +
                n +
                ', top=' +
                r +
                ', left=' +
                a
            );
          }
        })(C(t) + '?' + c(o), e);
    }
    function k(t, e) {
      var o = t.get('content', e);
      (o.t = e),
        (o.technique = 'client_redirect'),
        y(C(t) + '?' + c(o), function (t) {
          var e = window.onbeforeunload;
          (window.onbeforeunload = null),
            (window.location = t.redirect_url),
            setTimeout(function () {
              window.onbeforeunload = e;
            }, 0);
        });
    }
    function y(t, e) {
      var o = new XMLHttpRequest();
      o.open('GET', t),
        o.send(),
        (o.onreadystatechange = function (t) {
          if (o.readyState === XMLHttpRequest.DONE) {
            try {
              var i = JSON.parse(o.responseText);
            } catch (t) {
              return void console.log(o.responseText);
            }
            e(i);
          }
        });
    }
    function F(t, e) {
      switch (t) {
        case 'boolean':
          return void 0 !== e;
        default:
          return e;
      }
    }
    function L(t) {
      for (var e, o, i, n, r, a, s = {}, c = t.attributes, d = c.length - 1; d >= 0; d--)
        if ('data-' == (e = c[d].name).substr(0, 5)) {
          if (
            ((o = (e = e.substr(5)).split(':')),
            (i = l(o[0])),
            (r = F((n = f[i] || f._defaults).type, c[d].value)),
            (a = void 0),
            o[1])
          )
            if ('theme.hint' === n.group) a = 'theme.hint.' + o[1];
            else {
              if ('content' !== n.group) continue;
              a = 'contentByService.' + o[1] + '.' + i;
            }
          else a = n.group + '.' + i;
          b.set(s, a, r);
        }
      return s;
    }
    function D(t, e) {
      var o = e.get('content');
      for (var i in o) o.hasOwnProperty(i) && t.hasAttribute('data-' + i) && t.setAttribute('data-' + i, '' + o[i]);
      var n = e.get('contentByService');
      for (var r in n)
        if (n.hasOwnProperty(r))
          for (i in n[r])
            o.hasOwnProperty(i) &&
              t.hasAttribute('data-' + i + ':' + r) &&
              t.setAttribute('data-' + i + ':' + r, '' + n[r][i]);
    }
    function A(t, e) {
      var o = document.getElementsByTagName('head')[0] || document.body,
        i = document.createElement('style');
      (i.type = 'text/css'), (i.innerHTML = t), e && i.setAttribute('nonce', e), o.appendChild(i);
    }
    window.CT.init = function (t) {
      t &&
        (function (t, e) {
          var o = new w();
          o.merge(d);
          var i = L(t);
          o.merge(i),
            n(e) && (o.merge(e), D(t, o)),
            (t.innerHTML = h(o)),
            t.classList.add('social-btns'),
            t.classList.add('social-btns_inited');
          var r = o.get('theme.size');
          r && t.classList.add('social-btns_size_' + r), g || o.get('theme.bare') || (A(u), (g = !0)), new _(t, o);
        })(t);
    };
  },
]);
